export default __webpack_public_path__ + "static/media/floor3map.13db6e13.svg";